import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../../config/ApiUrl";
import ADMIN_API_URL from "../../../config/AdminApiUrl";

export const getTenants = createAsyncThunk(
  "Tenant/get",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setActivePayload(payload));
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== ""
        )
      );
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();
      const { data } = await axios.get(
        `${ADMIN_API_URL.TENANT.SLUG}?${queryString}`
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createTenant = createAsyncThunk(
  "Tenant/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${ADMIN_API_URL.TENANT.SLUG}`,
        payload
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const deleteTenant = createAsyncThunk(
  "Tenant/delete",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(`${ADMIN_API_URL.TENANT.SLUG}/${id}`);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const editTenant = createAsyncThunk(
  "Tenant/put",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(`${ADMIN_API_URL.TENANT.SLUG}`, payload);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const getTenantDetails = createAsyncThunk(
  "TenantDetails/get",
  async (Id, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${ADMIN_API_URL.TENANT.SLUG}/${Id}`);
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const tenantSlice = createSlice({
  name: "tenant",
  initialState: {
    tenant_list: [],
    state_list: [],
    current_values: null,
    active_payload: null,
    total_records: 0,
    tenant_details: {},
  },
  reducers: {
    setCurrentValues(state, action) {
      state.current_values = action.payload;
    },
    setActivePayload(state, action) {
      state.active_payload = action.payload;
    },
    resetCurrentValue(state) {
      state.current_values = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTenants.fulfilled, (state, action) => {
        state.tenant_list = action.payload.data.list;
        state.total_records = action.payload.data.totalRecords || 0;
      })
      .addCase(getTenantDetails.fulfilled, (state, action) => {
        state.tenant_details = action.payload;
      });
  },
});

export const { setCurrentValues, setActivePayload, resetCurrentValue } =
  tenantSlice.actions;
export default tenantSlice.reducer;
